"use client";

import * as React from "react";
import { Input, LiquidPill } from "components/ui/v2";
import { Search, X } from "lucide-react";

export interface PageToolbarV2Props {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  clearSearchLabel?: string;
  filters?: React.ReactNode;
  leftSlot?: React.ReactNode;
}

export function PageToolbarV2({
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "Buscar...",
  clearSearchLabel = "Limpiar búsqueda",
  filters,
  leftSlot,
}: PageToolbarV2Props) {
  const hasSearch = onSearchChange !== undefined;
  const showActiveChip = hasSearch && searchValue.length > 0;

  if (!hasSearch && !filters && !leftSlot) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {leftSlot}
      {showActiveChip && !leftSlot ? (
        <LiquidPill
          as="button"
          type="button"
          variant="emerald"
          appearance="tinted"
          size="sm"
          icon={<Search className="h-3 w-3" />}
          text={`"${searchValue}"`}
          onClick={() => onSearchChange?.("")}
          aria-label={clearSearchLabel}
        />
      ) : null}
      {hasSearch ? (
        <div className="w-64">
          <Input
            type="text"
            label={searchPlaceholder}
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(event) => onSearchChange?.(event.target.value)}
            size="filter"
            variant="subtle"
            leftIcon={<Search className="h-3.5 w-3.5" />}
            rightIcon={
              searchValue ? (
                <button
                  type="button"
                  onClick={() => onSearchChange?.("")}
                  className="pointer-events-auto text-slate-400 transition-colors hover:text-slate-700 dark:hover:text-zinc-100"
                  aria-label={clearSearchLabel}
                >
                  <X className="h-3.5 w-3.5" />
                </button>
              ) : null
            }
          />
        </div>
      ) : null}
      {filters}
    </div>
  );
}
